import React from "react";

const LoadingDom: React.FC<{ isLoading?: boolean; children?: React.ReactNode }> = ({ isLoading = true, children }) => {
  if (!isLoading) return <>{children}</>;
  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f7f8fa",
        zIndex: 9999,
        position: "fixed",
        top: 0,
        left: 0,
      }}
    >
      <div style={{ textAlign: "center" }}>
        <span
          className="fa fa-spinner fa-spin"
          style={{ fontSize: 40, color: "#2d6cff" }}
        />
        <div style={{ marginTop: 16, color: "#888", fontSize: 16 }}>
          页面加载中，请稍候...
        </div>
      </div>
    </div>
  );
};

export default LoadingDom;
